export default __webpack_public_path__ + "static/media/hero-bg.d803bce2.png";